<template>
  <div>
    <div class="titlePage">{{ titlePage }}</div>
    <fccTable
      class="mt-3"
      :addFilter="controlePage.qtdecidade == 1 && lstCidades.length == 0"
      striped
      hover
      :fields="fieldsCidades"
      orderby="codcidexame"
      :items="lstCidades"
      :titlePage="titlePage"
      :titlePDF="titlePage"
    />
    <fccModal
      centered
      idModal="addFieldCidade"
      titleModal="Cidade"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
    >
      <form @submit.prevent="add ? addCidade() : editCidade()" autocomplete="off">
        <div class="publicaBox">
          <div class="row mt-2">
            <fcc-input
              v-model="cidade.codcidexame"
              required
              type="number"
              disabled
              class="col-sm-4 mt-1"
            >
              Código Cidade</fcc-input
            >
            <fcc-input v-model="cidade.descricao" required class="col-sm-8 mt-1">
              Descrição</fcc-input
            >
          </div>
        </div>
        <div class="row my-4">
          <div class="col-sm-12 text-right">
            <fccButton tipo="submit">Salvar</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      spi: '',
      titlePage: 'Cargo(s)',
      add: false,
      cidade: {
        codcidexame: 0,
        descricao: ''
      },
      baseUrlPublicacao: store.state.baseUrlPublicacao,
      lstCidades: [],
      fieldsCidades: [
        { key: 'codopcao', label: 'Código Opção', active: true },
        { key: 'descricao', label: 'Descrição', active: true },
        {
          key: 'fldiscursiva',
          label: 'Prova Discursiva',
          active: true,
          type: 'toggle',
          funcaoButton: 'editDiscursiva',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    addField: function () {
      this.add = true
      this.$root.$emit('bv::show::modal', 'addFieldCidade')
    },
    editDiscursiva(_, item) {
      this.editCurso(item)
    },
    addCidade() {
      const cidade = {
        spi: this.spi,
        codcidexame: this.cidade.codcidexame,
        descricao: this.cidade.descricao,
        fldisponivel: 1
      }
      this.carregaTexto(this.codeMensagem('C01'))
      this.inserirCidadeSPI([cidade])
        .then(() => {
          this.buscarCargosSPI()
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch(this.setErrorSystem)
        .finally(() => {
          this.carregaTexto()
          this.$root.$emit('bv::show::modal', 'addFieldCidade')
        })
    },
    editCurso(curso) {
      this.carregaTexto(this.codeMensagem('C01'))
      delete curso.id
      axios
        .put(
          `${this.baseUrlPublicacao}PublicacaoCargoInscricao/Alterar`,
          [curso],
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.buscarCargosSPI()
        })
        .catch(this.setErrorSystem)
    },
    buscarCargosSPI() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          `${this.baseUrlPublicacao}PublicacaoCargoInscricao/ListarCargoInscricaoPorSpi/${this.spi}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCidades = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted() {
    this.spi =
      this.controlePage.spiPublicacao == null
        ? this.controlePage.spi
        : this.controlePage.spiPublicacao
    this.buscarCargosSPI()
  },
  props: {
    idPublicacao: Number,
    controlePage: Object
  }
}
</script>